import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import DocumentDetail from "@/pages/DocumentDetail";
import GenerateFlow from "@/pages/GenerateFlow";
import Success from "@/pages/Success";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";
import {
  HowItWorks,
  FAQ,
  Privacy,
  Terms,
  Cookie,
  Contact,
} from "@/pages/StaticPages";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/documente/:slug" element={<DocumentDetail />} />
          <Route path="/documente/:slug/genereaza" element={<GenerateFlow />} />
          <Route path="/succes" element={<Success />} />
          <Route path="/plata-anulata" element={<PaymentCancel />} />
          <Route path="/cum-functioneaza" element={<HowItWorks />} />
          <Route path="/intrebari-frecvente" element={<FAQ />} />
          <Route path="/confidentialitate" element={<Privacy />} />
          <Route path="/termeni" element={<Terms />} />
          <Route path="/cookie" element={<Cookie />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
